import { render, staticRenderFns } from "./ImagePreviewDialog.vue?vue&type=template&id=5b1dfd06&"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewDialog.vue?vue&type=style&index=0&id=5b1dfd06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports